<script>
export default {
  name: 'MainNavItem',

  props: {
    tagName: {
      type: String,
      default: 'li',
    },
    id: Number,
    type: String,
    title: String,
    url: String,
    target: String,
    active: Boolean,
    children: [Array, null],
    theme: String,
    dropdownTheme: String,
    dropdownOpen: Boolean,
  },

  computed: {
    hasChildren () {
      return this.children && this.children.length > 0
    },
    themeClass () {
      return `main-nav-item--theme-${this.theme}`
    },
    classList () {
      return {
        'main-nav-item': true,
        'main-nav-item--has-children': this.hasChildren,
        'main-nav-item--dropdown-open': this.dropdownOpen,
        'main-nav-item--active': this.active,
        [this.themeClass]: true,
      }
    },
    dropdownThemeClass () {
      return `main-nav-item__dropdown--theme-${this.theme}`
    },
    dropdownClassList () {
      return {
        'main-nav-item__dropdown': true,
        [this.dropdownThemeClass]: true,
      }
    },
    dropdownButtonAriaExpanded () {
      return this.dropdownOpen ? 'true' : 'false'
    },
    dropdownId () {
      return `main-nav-item-dropdown-${this.id}`
    },
  },

  methods: {
    toggleDropdown () {
      if (this.dropdownOpen) {
        this.$emit('dropdown-closed', this.id)
      } else {
        this.$emit('dropdown-opened', this.id)
      }
    },
    dropdownShouldExpand (element) {
      return getComputedStyle(element).willChange === 'height'
    },
    dropdownEnter (element) {
      if (!this.dropdownShouldExpand(element)) {
        return
      }

      const width = getComputedStyle(element).width

      element.style.width = width
      element.style.position = 'absolute'
      element.style.visibility = 'hidden'
      element.style.height = 'auto'

      const height = getComputedStyle(element).height

      element.style.width = null
      element.style.position = null
      element.style.visibility = null
      element.style.height = 0

      getComputedStyle(element).height

      requestAnimationFrame(() => {
        element.style.height = height
      })
    },
    dropdownAfterEnter (element) {
      if (!this.dropdownShouldExpand(element)) {
        return
      }

      element.style.height = 'auto'
    },
    dropdownLeave (element) {
      if (!this.dropdownShouldExpand(element)) {
        return
      }

      const height = getComputedStyle(element).height

      element.style.height = height

      getComputedStyle(element).height

      requestAnimationFrame(() => {
        element.style.height = 0
      })
    },
  },
}
</script>

<template>
  <component
    :is="tagName"
    :class="classList"
  >
    <template v-if="hasChildren">
      <button
        class="main-nav-item__dropdown-button"
        :aria-controls="dropdownId"
        :aria-expanded="dropdownButtonAriaExpanded"
        @click="toggleDropdown"
      >
        {{ title }}
        <i class="main-nav-item__dropdown-button-icon far fa-angle-down"></i>
      </button>

      <Transition
        name="main-nav-item-dropdown"
        @enter="dropdownEnter"
        @after-enter="dropdownAfterEnter"
        @leave="dropdownLeave"
      >
        <div
          :class="dropdownClassList"
          :id="dropdownId"
          v-if="dropdownOpen"
        >
          <ul class="main-nav-item__dropdown-list">
            <li v-if="type !== 'folder'">
              <a
                :href="url"
                :target="target"
                class="main-nav-item__dropdown-heading"
              >
                {{ title }}
                <i class="fal fa-arrow-right"></i>
              </a>
            </li>
            <li
              v-for="child in children"
              :key="child.id"
            >
              <a
                class="main-nav-item__dropdown-link"
                :href="child.url"
                :target="child.target"
              >
                {{ child.title }}
              </a>
            </li>
          </ul>
        </div>
      </Transition>
    </template>
    <a
      v-else
      class="main-nav-item__link"
      :href="url"
      :target="target"
    >
      {{ title }}
    </a>
  </component>
</template>
